import { baseUrl } from './Config.js'

const getHeaders = (authorization = false, token = "") => {
    var headers = new Headers();
    headers.append("Content-Type", "application/json; charset=utf-8");
    if (authorization){
        headers.append("Authorization", "Bearer " + token);
    }

    return headers;
}

const build = (status, message, data) => {
    return {status, message, data}
}

export const LoginRequest = async (username, password) => {

    var requestOptions = {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({username, password}),
        redirect: 'follow'
    };

    return fetch(baseUrl + "api/v1.0/Login", requestOptions)
        .then(response => {
            if (response.status === 200) {
                return response.text()
            } else {
                throw build(response.status, response.status === 403 ? "Usuario y/o contraseña incorrectos" : "Ha ocurrido un error", null)
            }
        })
        .then(result => {
            result = JSON.parse(result);
            return build(200, "¡Bienvenido!", result.data[0])
        })
        .catch(error => {
            return error;
        });
}

export const SaveMenu = async (menu) => {

    var requestOptions = {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(menu),
        redirect: 'follow'
    };

    return fetch(baseUrl + "api/v1.0/Menu", requestOptions)
        .then(response => {
            if (response.status === 200) {
                return response.text()
            } else {
                throw build(response.status, response.status === 403 ? "Usuario y/o contraseña incorrectos" : "Ha ocurrido un error", null)
            }
        })
        .then(result => {
            result = JSON.parse(result);
            return build(200, "Datos Guardados!", result.data)
        })
        .catch(error => {
            return error;
        });
}

export const GetMenu = async () => {

    var requestOptions = {
        method: 'GET',
        headers: getHeaders(),
        redirect: 'follow'
    };

    return fetch(baseUrl + "api/v1.0/Menu", requestOptions)
        .then(response => {
            if (response.status === 200) {
                return response.text()
            } else {
                throw build(response.status, response.status === 403 ? "Usuario y/o contraseña incorrectos" : "Ha ocurrido un error", null)
            }
        })
        .then(result => {
            result = JSON.parse(result);
            return build(200, "¡Bienvenido!", result.data)
        })
        .catch(error => {
            return error;
        });
}